import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HTTPService } from './http.service';
import { UserAuthenticationServices } from './user-authentication.services';

export type LayoutVersion =  'light_modern' | 'light' | 'dark' | 'vault' | 'warm' | 'violet' | 'orange' | 'brasil' | 'zorro' | 'bootstrap' | 'custom';

@Injectable({
  providedIn: 'root'
})
export class LayoutVersionService {
  private httpService = inject(HTTPService);
  private userAuthService = inject(UserAuthenticationServices);
  
  private layoutVersionSubject = new BehaviorSubject<LayoutVersion>('light');
  public layoutVersion$ = this.layoutVersionSubject.asObservable();

  constructor() {
    this.initializeLayoutVersion();
  }

  private initializeLayoutVersion(): void {
    this.loadLayoutVersionFromServer();
  }

  private loadLayoutVersionFromServer(): void {
    const user = this.userAuthService.user;
    
    if (!user || !user.iduser) {
      // Se não houver usuário, usa padrão
      this.layoutVersionSubject.next('light_modern');
      return;
    }
    
    this.layoutVersionSubject.next(user.layout as LayoutVersion || 'light_modern');
  }

  /**
   * Retorna a versão atual do layout
   */
  getCurrentLayoutVersion(): LayoutVersion {
    return this.layoutVersionSubject.getValue();
  }

  /**
   * Re-lê o layout do usuário (já atualizado pelo reloadUser) e emite
   * se mudou — permite trocar de tema sem F5 a partir do user-form-config
   */
  refresh(): void {
    const user = this.userAuthService.user;
    const version = (user?.layout as LayoutVersion) || 'light_modern';
    if (version !== this.layoutVersionSubject.getValue()) {
      this.layoutVersionSubject.next(version);
    }
  }

}
